<template>
  <div>
    <div v-if="mediaType === 'IMAGE'">
      <v-img
        v-if="mediaUrl"
        class="align-center text-center template-default-img"
        :src="mediaUrl"
        cover
        position="center center">
      </v-img>
    </div>
    <div v-if="mediaType === 'VIDEO' && mediaUrl">
      <iframe class="align-center text-center template-default-img" :src="mediaUrl" height="247.5px">
      </iframe>
    </div>

  </div>
</template>

<script>
import {mapMutations, mapGetters} from 'vuex'

export default {
  name: 'templateMedia',
  data () {
    return {
      mediaUrl: '',
      mediaType: ''
    }
  },
  computed: {
    ...mapGetters([
      'marketingTemplateContent',
      'marketingTemplateContentMedia'
    ])
  },
  watch: {
    marketingTemplateContent () {
      this.initImage()
    },
    marketingTemplateContentMedia () {
      this.mediaType = this.marketingTemplateContentMedia.type
      this.mediaUrl = this.marketingTemplateContentMedia.url
    }
  },
  destroyed () {
  },
  mounted () {
    this.initImage()
  },
  methods: {
    ...mapMutations([
    ]),
    initImage () {
      if (this.marketingTemplateContent.content) {
        let textContent = this.marketingTemplateContent.content
        this.mediaType = textContent.mediaType
        this.mediaUrl = textContent.imageUrl
      } else {
        this.mediaUrl = ''
        this.mediaType = ''
      }
    }
  }
}
</script>

<style scoped>
  /* @import url("../css/marketingFlexEditor.css"); */
  .template-default-img {
    width: 100%;
    vertical-align: middle;
    border-radius: 20px 20px 0 0;
    border: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/push/components/templateFragments/templateMedia.vue